import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import translate from '../../../../../../commonComponents/translate';
import {
  compose,
  formatURL,
} from '../../../../../../services/utilityFunctions';
import FormSubtitle from '../../../../../../commonComponents/forms/FormSubtitle';
import { useModal } from '../../../../../../services/customHooks';
import ConnectorCalendlyModal from './ConnectorCalendlyModal';
import withCSRF from '../../../../../../commonComponents/withCSRF';
import Notifications from '../../../../../../services/notifications';
import OrganizationProp from '../../../../../../commonComponents/propTypes/organizationProp';
import TenantProp from '../../../../../../commonComponents/propTypes/tenantProp';

function ConnectorCalendly(props) {
  const { t, calendlyService, tenant, organization, _csrf } = props;
  const { userPortal } = tenant?.configs;
  const { configured } = organization?.services?.calendly?.config;

  const calendlyEnabled = calendlyService.configured || false;

  const calendlyStatus = calendlyEnabled ? t('enabled') : t('disabled');

  const [calendlyHref, setCalendlyHref] = React.useState();
  const [{ show: isModalShown }, setShowModal] = useModal({ show: false });

  const showModal = evt => {
    evt.preventDefault();
    setShowModal({ show: true });
  };
  const hideModal = () => setShowModal({ show: false });

  const calendlyRedirectUrl = `${formatURL(userPortal)}connect/calendly`;

  // https://portal-dev.bravon.io/connect/calendly

  const calendlyLink = async () => {
    await axios
      .get('/api/auth/user/calendly/authenticationUrl', {
        params: {
          redirectUrl: calendlyRedirectUrl,
        },
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Auth',
        },
      })
      .then(response => {
        setCalendlyHref(response.data.data);
      });
  };

  const confirmRemoveCalendly = useCallback(async () => {
    await axios
      .delete('/api/auth/user/calendly/token', {
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Auth',
          'X-CSRF-Token': _csrf,
          _csrf,
        },
      })
      .then(() => {
        window.location.reload();
      })
      .catch(err => Notifications.showErrorFromRequest(err));
  }, []);

  useEffect(() => {
    if (calendlyRedirectUrl?.length > 0) {
      calendlyLink();
    }
  }, [calendlyLink, userPortal]);

  const handleAuthentication = useCallback(async () => {
    if (!calendlyHref) {
      return;
    }
    window.open(calendlyHref, '_blank');
  }, [calendlyHref]);

  return (
    <>
      {/* TODO: Calendly Logo/Icon */}
      {isModalShown && (
        <ConnectorCalendlyModal
          t={t}
          handleRemoveCalendly={confirmRemoveCalendly}
          onClose={hideModal}
        />
      )}
      <FormSubtitle title={t('profile.connectors.tab.connector.calendly')} />
      <div>
        <h5>{`${t(
          'profile.connectors.tab.connector.calendly.status',
        )} - ${calendlyStatus}`}</h5>
      </div>
      {calendlyEnabled ? (
        <button
          type="button"
          onClick={showModal}
          className="btn btn-danger m-btn m-btn--air"
        >
          {t('btn.disable')}
        </button>
      ) : (
        <button
          type="button"
          onClick={handleAuthentication}
          disabled={!configured}
          className="mx-5 btn btn-accent m-btn m-btn--air m-btn--custom calendly-btn"
        >
          {t('btn.enable')}
        </button>
      )}
    </>
  );
}

ConnectorCalendly.propTypes = {
  /** translation function */
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  calendlyService: PropTypes.shape({
    configured: PropTypes.bool.isRequired,
    config: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
  organization: PropTypes.shape(OrganizationProp.propType).isRequired,
  tenant: PropTypes.shape(TenantProp.propType).isRequired,
};

ConnectorCalendly.defaultProps = {
  calendlyService: {
    enabled: false,
  },
};

export default compose(translate, withCSRF)(ConnectorCalendly);
